import { createSlice } from "@reduxjs/toolkit";
import {
  fetchFrasesPlantelThunk,
  createFrasePlantelThunk,
  updateFrasePlantelThunk,
  toggleFrasePlantelActiveThunk,
  fetchSubFrasesPlantelThunk,
  createSubFrasePlantelThunk,
  updateSubFrasePlantelThunk,
  toggleSubFrasePlantelActiveThunk,
} from "./preguntasTalentoPlantel.thunks";

const paginated = () => ({ results: [], count: 0, next: null, previous: null });

const initialState = {
  frases: { data: paginated(), loading: false, error: null },
  subFrases: { data: paginated(), loading: false, error: null },
};

const replaceInResults = (results, updated) =>
  results.map((item) => (item.id === updated.id ? { ...item, ...updated } : item));

const slice = createSlice({
  name: "preguntasTalentoPlantel",
  initialState,
  reducers: {
    resetPreguntasTalentoPlantelState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFrasesPlantelThunk.pending, (s) => { s.frases.loading = true; s.frases.error = null; })
      .addCase(fetchFrasesPlantelThunk.fulfilled, (s, a) => { s.frases.loading = false; s.frases.data = a.payload; })
      .addCase(fetchFrasesPlantelThunk.rejected, (s, a) => { s.frases.loading = false; s.frases.error = a.payload; })
      .addCase(createFrasePlantelThunk.fulfilled, (s, a) => {
        s.frases.data.results = [a.payload, ...s.frases.data.results];
        s.frases.data.count += 1;
      })
      .addCase(updateFrasePlantelThunk.fulfilled, (s, a) => {
        s.frases.data.results = replaceInResults(s.frases.data.results, a.payload);
      })
      .addCase(toggleFrasePlantelActiveThunk.fulfilled, (s, a) => {
        s.frases.data.results = replaceInResults(s.frases.data.results, a.payload);
      });

    builder
      .addCase(fetchSubFrasesPlantelThunk.pending, (s) => { s.subFrases.loading = true; s.subFrases.error = null; })
      .addCase(fetchSubFrasesPlantelThunk.fulfilled, (s, a) => { s.subFrases.loading = false; s.subFrases.data = a.payload; })
      .addCase(fetchSubFrasesPlantelThunk.rejected, (s, a) => { s.subFrases.loading = false; s.subFrases.error = a.payload; })
      .addCase(createSubFrasePlantelThunk.fulfilled, (s, a) => {
        s.subFrases.data.results = [a.payload, ...s.subFrases.data.results];
        s.subFrases.data.count += 1;
      })
      .addCase(updateSubFrasePlantelThunk.fulfilled, (s, a) => {
        s.subFrases.data.results = replaceInResults(s.subFrases.data.results, a.payload);
      })
      .addCase(toggleSubFrasePlantelActiveThunk.fulfilled, (s, a) => {
        s.subFrases.data.results = replaceInResults(s.subFrases.data.results, a.payload);
      });
  },
});

export const { resetPreguntasTalentoPlantelState } = slice.actions;
export default slice.reducer;
